import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { ConnectCTraderDialog } from '../ConnectCTraderDialog';
import { PlatformHeader } from './PlatformHeader';
import { PlatformContent } from './PlatformContent';

interface PlatformCardProps {
  name: string;
  shortName: string;
  logo: string;
  description: string;
  features?: string[];
  connected?: boolean;
  className?: string;
  onManage?: () => void;
  isSupported?: boolean;
  logosLoading?: boolean;
}

export const PlatformCard = ({
  name,
  shortName,
  logo,
  description,
  features = [],
  connected = false,
  className,
  onManage,
  isSupported = false,
  logosLoading = false
}: PlatformCardProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const navigate = useNavigate();
  const isCTrader = name === 'cTrader';

  const handleAction = () => {
    if (!isSupported) return;
    
    // For cTrader, only show dialog if not connected
    if (isCTrader) {
      if (!connected) {
        setIsDialogOpen(true);
      } else {
        // Navigate to manage cTrader profiles page
        navigate('/manage-ctrader-profiles');
      }
    } else if (connected && onManage) {
      // For other platforms, use standard manage behavior
      onManage();
    }
  };

  return (
    <>
      <Card className={cn("overflow-hidden transition-all hover:border-primary/30", className)}>
        <CardHeader className="border-b border-border bg-muted/50 p-4">
          <PlatformHeader 
            name={name} 
            shortName={shortName} 
            logo={logo} 
            connected={connected}
            isSupported={isSupported}
            loading={logosLoading}
          />
        </CardHeader>
        <CardContent className="p-4">
          <PlatformContent 
            description={description} 
            features={features} 
            connected={connected}
            onAction={handleAction}
            isSupported={isSupported}
          />
        </CardContent>
      </Card>
      {isCTrader && !connected && (
        <ConnectCTraderDialog 
          open={isDialogOpen} 
          onOpenChange={setIsDialogOpen} 
        />
      )}
    </>
  );
};
